// extracted by mini-css-extract-plugin
export default {"main":"Game_main__vUBU8","info":"Game_info__zbuju","details":"Game_details__99W83"};